import React, { useEffect } from 'react'
import { FiArrowLeftCircle, FiPlusSquare } from 'react-icons/fi'
import { CardDataCustomer } from '../../components/CardDataCustomer'
import { CardSummary } from '../../components/CardSummary'
import { Memberships } from './tabs/memberships/Memberships'
import { Billings } from './tabs/billings/Billings'
import { Orders } from './tabs/orders/Orders'
import { Sales } from './tabs/sales/Sales'
import { icosIndicators } from '../../app/Paths'
import { Loading } from '../../components/Loading'
import { useDispatch, useSelector } from 'react-redux'
import { loadDevices, loadCustomer, loadIndicators, loadOrders, loadSales, loadBillings, setCustomerClearDetail, loadCatMemberships, loadMemberships } from '../store/Thunk'
import { Devices } from './tabs/devices/Devices'
// import { Devices } from './tabs/Devices/Devices'

export const CustomerDetail = () => {


    const goBack = () => {
        dispatch(setCustomerClearDetail())
    }

    const dispatch = useDispatch();
    const { isLoading, idCustomer, indicators, dataCustomer, devices, memberships, billings, orders, sales, msg } = useSelector(state => state.customerDetail);

    useEffect(() => {
        dispatch(loadCatMemberships());
        dispatch(loadMemberships(idCustomer || 0));
        dispatch(loadCustomer(idCustomer || 0));
        dispatch(loadDevices(idCustomer || 0));
        dispatch(loadIndicators(idCustomer || 0));
        dispatch(loadOrders(idCustomer || 0));
        dispatch(loadSales(idCustomer || 0));
        dispatch(loadBillings(idCustomer || 0));
    }, [])

    // Extraccion de indicadores
    let indicadorVentas = Number(indicators?.['ventas']?.['CONTEO']) + Number(indicators?.['ventasp']?.['CONTEO']);
    let indicadorOrdenActiva = indicators?.['ordenes']?.[0]?.['CONTEO'];
    let indicadorOrdenCerrada = indicators?.['ordenes']?.[1]?.['CONTEO'];
    let indicadorOrdenCancelada = indicators?.['ordenes']?.[2]?.['CONTEO'];



    return (
        <div className='row'>
            <div className='col-12 mb-3'>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center" >
                    <div className="d-flex mb-1">
                        <button className="btn btn-outline-dark border-0" onClick={goBack} >
                            <FiArrowLeftCircle size={23} />
                        </button>
                        <h1 className="h4 fw-bold mt-2"> | Detalle de Cliente </h1>
                    </div>
                </div>
            </div>

            {/* Data Customer */}
            <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-2'>
                <CardDataCustomer data={dataCustomer} variant={1} />
            </div>
            {/* Indicators */}
            <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-10'>
                <div className='row'>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <CardSummary title={'Ordenes activas'} type={0} value={indicadorOrdenActiva || 0} icon={'active'} />
                    </div>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <CardSummary title={'Ordenes cerradas'} type={0} value={indicadorOrdenCerrada || 0} icon={'orders'} />
                    </div>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <CardSummary title={'Ordenes canceladas'} type={0} value={indicadorOrdenCancelada || 0} icon={'error'} />
                    </div>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <CardSummary title={'Ventas'} type={0} value={indicadorVentas || 0} icon={'sales'} />
                    </div>
                    {/* <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <CardSummary title={'Ganancias'} type={1} value={10000} icon={'earnings'} />
                    </div> */}
                </div>

                {/* Categories */}
                <div className='row'>
                    <div className='col-12'>
                        <div className="card">
                            <div className="card-body">
                                <ul className="nav nav-underline mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="pills-services-tab" data-bs-toggle="pill" data-bs-target="#pills-services" type="button" role="tab" aria-controls="pills-services" aria-selected="true">
                                            {/* <img src={icosIndicators['devices']} className="img-fluid" width={28} alt="devices" /> */}
                                            <span className='ms-2 me-2'>Equipos</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button  className="nav-link" id="pills-repairs-tab" data-bs-toggle="pill" data-bs-target="#pills-repairs" type="button" role="tab" aria-controls="pills-repairs" aria-selected="false">
                                            {/* <img src={icosIndicators['memberships']} className="img-fluid" width={29} alt="devices" /> */}
                                            <span className='ms-2 me-2'>Membresias</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="pills-avancedPayments-tab" data-bs-toggle="pill" data-bs-target="#pills-avancedPayments" type="button" role="tab" aria-controls="pills-avancedPayments" aria-selected="false">
                                            {/* <img src={icosIndicators['checklist']} className="img-fluid" width={28} alt="devices" /> */}
                                            <span className='ms-2 me-2'>Facturacion</span>
                                        </button>
                                    </li>

                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="pills-orders-tab" data-bs-toggle="pill" data-bs-target="#pills-orders" type="button" role="tab" aria-controls="pills-orders" aria-selected="false">
                                            {/* <img src={icosIndicators['orders']} className="img-fluid" width={28} alt="devices" /> */}
                                            <span className='ms-2 me-2'>Ordenes</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="pills-sales-tab" data-bs-toggle="pill" data-bs-target="#pills-sales" type="button" role="tab" aria-controls="pills-sales" aria-selected="false">
                                            {/* <img src={icosIndicators['sales']} className="img-fluid" width={28} alt="devices" /> */}
                                            <span className='ms-2 me-2'>Ventas</span>
                                        </button>
                                    </li>
                                </ul>

                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-services" role="tabpanel" aria-labelledby="pills-services-tab" >
                                        <Devices />
                                    </div>
                                    <div className="tab-pane fade" id="pills-repairs" role="tabpanel" aria-labelledby="pills-repairs-tab" >
                                        <Memberships />
                                    </div>
                                    <div className="tab-pane fade" id="pills-avancedPayments" role="tabpanel" aria-labelledby="pills-avancedPayments-tab" >
                                        <Billings />
                                    </div>
                                    <div className="tab-pane fade" id="pills-orders" role="tabpanel" aria-labelledby="pills-orders-tab" >
                                        <Orders />
                                    </div>
                                    <div className="tab-pane fade" id="pills-sales" role="tabpanel" aria-labelledby="pills-sales-tab" >
                                        <Sales />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
